// For Repository PresetAssociation

import type { AsyncData } from '#app';
import type { IModelResponse } from '~/services/base/dto/base.dto';
import type {
  IModelGETPresetAssociationPresetResponse,
  IModelPresetActiveResponse,
  IModelSharePointIndexingResponse,
  IModelSharePointResponse,
} from './dto/preset-asso.dto';

export class PresetAssociationRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getPresetAssociationPreset(
    id: string
  ): Promise<
    AsyncData<IModelResponse<IModelGETPresetAssociationPresetResponse>, any>
  > {
    const dataResult = await this.api(
      `${this.llmService}/v1/preset-association/preset/${id}`,
      this.configService
    );
    return dataResult;
  }

  async postPresetAssociationPreset(
    formData: FormData
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/preset-association/preset`,
      this.configService,
      {
        method: 'POST',
        body: formData,
      }
    );
    return dataResult;
  }
  async putPresetAssociationPreset(
    formData: FormData
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/preset-association/preset`,
      this.configService,
      {
        method: 'PUT',
        body: formData,
      }
    );
    return dataResult;
  }
  async putPresetAssociationPresetDuplication(
    formData: FormData
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/preset-association/preset-duplication`,
      this.configService,
      {
        method: 'PUT',
        body: formData,
      }
    );
    return dataResult;
  }

  async getPresetAssociationPresetActive(
    params: any
  ): Promise<AsyncData<IModelResponse<IModelPresetActiveResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/preset-association/preset-active`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getSiteList(params: any): Promise<any> {
    const dataResult = await this.api(
      `${this.llmService}/v1/sharepoint/sites`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getDriveList(siteId: any): Promise<any> {
    const dataResult = await this.api(
      `${this.llmService}/v1/sharepoint/sites/${siteId}/drives`
    );
    return dataResult;
  }

  async getDriveItemList(siteId: any, driveId: any): Promise<any> {
    const dataResult = await this.api(
      `${this.llmService}/v1/sharepoint/sites/${siteId}/drives/${driveId}/items/root/children`
    );
    return dataResult;
  }

  async getSharePoint(
    id: string
  ): Promise<AsyncData<IModelResponse<IModelSharePointResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/preset-sharepoint?presetId=${id}`,
      this.configService
    );
    return dataResult;
  }

  async createSharepoint(
    params: any
  ): Promise<AsyncData<IModelResponse<IModelSharePointResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/preset-sharepoint/bulk`,
      this.configService,
      {
        method: 'POST',
        body: params,
      }
    );
    return dataResult;
  }

  async deleteSharepoint(
    params: any
  ): Promise<AsyncData<IModelResponse<IModelSharePointResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/preset-sharepoint/bulk`,
      this.configService,
      {
        method: 'PUT',
        body: params,
      }
    );
    return dataResult;
  }

  async postSharepointIndexing(
    formData: any
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/sharepoint-association/indexing`,
      this.configService,
      {
        method: 'POST',
        body: { data: formData },
      }
    );
    return dataResult;
  }

  async getSharePointIndexing(
    id: string
  ): Promise<AsyncData<IModelResponse<IModelSharePointIndexingResponse>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/sharepoint-association/indexing/${id}`,
      this.configService
    );
    return dataResult;
  }

  async getDepartmentList(params: any): Promise<any> {
    const dataResult = await this.api(
      `${this.llmService}/v1/department-mapping`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getUserList(params: any): Promise<any> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-association/user-department`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }
}
